import {
  concentrationUnitTypePredicate,
  containerQuantityUnitTypePredicate,
  massUnitTypePredicate,
  molUnitTypePredicate,
  volumeUnitTypePredicate,
} from 'inventory/InventoryUnitUtil';
import {
  stoichiometryAmountUnitTypePredicate,
  stoichiometryConcentrationUnitTypePredicate,
} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryUnits';
import type {UnitTypeFilter} from 'units/UnitsConstants';

export enum UnitTypePredicates {
  VOLUME = 'VOLUME',
  CONCENTRATION = 'CONCENTRATION',
  CONTAINER = 'CONTAINER',
  MOL = 'MOL',
  MASS = 'MASS',
  STOICHIOMETRY_AMOUNT = 'STOICHIOMETRY_AMOUNT',
  STOICHIOMETRY_CONCENTRATION = 'STOICHIOMETRY_CONCENTRATION',
}

export const UNIT_TYPE_PREDICATES: {[type in UnitTypePredicates]: UnitTypeFilter} = {
  [UnitTypePredicates.VOLUME]: volumeUnitTypePredicate,
  [UnitTypePredicates.CONCENTRATION]: concentrationUnitTypePredicate,
  [UnitTypePredicates.CONTAINER]: containerQuantityUnitTypePredicate,
  [UnitTypePredicates.MOL]: molUnitTypePredicate,
  [UnitTypePredicates.MASS]: massUnitTypePredicate,
  [UnitTypePredicates.STOICHIOMETRY_AMOUNT]: stoichiometryAmountUnitTypePredicate,
  [UnitTypePredicates.STOICHIOMETRY_CONCENTRATION]: stoichiometryConcentrationUnitTypePredicate,
};

export function getPredicate(type: UnitTypePredicates): UnitTypeFilter {
  return UNIT_TYPE_PREDICATES[type];
}

export function getPredicateType(predicate: UnitTypeFilter): UnitTypePredicates | undefined {
  return Object.values(UnitTypePredicates).find((type) => UNIT_TYPE_PREDICATES[type] === predicate);
}
